import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { getCourseTestimonials } from '../../utils/api';
import Spinner from '../Spinner/Spinner';
import './learner-feedback-styles.css';

class LearnerFeedbackCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lClassName: 'learner-feedback',
      feedbackData: {},
      feedbackDataLength: 0,
      itemClass: 'learner-feedback',
      isLoading: true,
      course_id: 0
    }
    this.feedbackApiCall = this.feedbackApiCall.bind(this);
  }

  componentDidMount() {
    if (window.productCourseId) {
      this.setState({ course_id: window.productCourseId });
      this.feedbackApiCall(window.productCourseId);
    }
  }

  async feedbackApiCall(course_id) {
    const allFeedbackData = await getCourseTestimonials(course_id, 1, 25);
    let courseFeedbackData = allFeedbackData.data.data;
    this.setState({ feedbackData: courseFeedbackData });
    this.setState({ feedbackDataLength: courseFeedbackData.data.length });
    this.setState({ isLoading: false });
    /* Execute detailing of buttons */
    this.detailControlButtons();
  }

  /**
   * @method - detailControlButtons - adds accessibility and font-awesome assets to the control buttons
   */
  detailControlButtons = () => {
    /* Create <i> element for font-awesome use */
    var prevArrowIcon = document.createElement('i');
    var nextArrowIcon = document.createElement('i');
    prevArrowIcon.className = 'fas fa-angle-left';
    nextArrowIcon.className = 'fas fa-angle-right';
    prevArrowIcon.setAttribute('aria-hidden', 'true');
    nextArrowIcon.setAttribute('aria-hidden', 'true');

    /* Access this carousel in the DOM */
    const learnerFeedbackCarousel = document.querySelector('#learnerFeedbackCarousel');
    /* Access button controls */
    const controlArrow = learnerFeedbackCarousel.querySelectorAll('.control-arrow');
    /* Run loop to add accessibility and detail to buttons */
    controlArrow.forEach(element => {
      var buttonLabel = (element.classList.contains('control-prev')) ? "Previous Slide" : "Next Slide";
      element.setAttribute('aria-hidden', 'false');
      element.setAttribute('aria-label', buttonLabel);
      element.setAttribute('tabindex', '0');
      element.setAttribute('role', 'button');

      if (element.classList.contains('control-prev')) {
        element.appendChild(prevArrowIcon);
      } else {
        element.appendChild(nextArrowIcon);
      }
    });
  }


  render() {
    const styleMinHeight = {
      'minHeight': '17.5em',
      'position': 'relative'
    };
    return (
      <React.Fragment>
        {(this.state.isLoading) ?
          <div style={styleMinHeight}>
            <Spinner isLoading={this.state.isLoading}></Spinner>
          </div>
          : ''}

        {(this.state.feedbackDataLength > 0) ?
          <div className="learner-feedbackCarousel__block" style={styleMinHeight}>
            <div className="learner-response__carousel__mtitle__block">
              <div className="learner-response__carousel__cmd12--1 col-md-12">
                <h3 className="learner-response__carousel__title ubuntu" aria-label="Learner Feedback Carousel">Learner Feedback</h3>
              </div>
            </div>
            <Carousel
              showArrows={true}
              showStatus={false}
              autoPlay={true}
              showIndicators={true}
              showThumbs={false}
              infiniteLoop={true}
              interval={5000}
              transitionTime={600}
              dynamicHeight={true}
            >
              {(typeof (this.state.feedbackData.data) !== 'undefined') ? this.state.feedbackData.data.map((feedback, index) =>
                <React.Fragment key={index}>
                  <div className={this.state.itemClass + '__testament testimonial'} tabIndex="0">
                    <h4 className={this.state.itemClass + '__student__name'}>{feedback.testimonial.first_name + ' ' + feedback.testimonial.last_name}</h4>

                    {feedback.testimonial.title.substring(0, feedback.testimonial.title.length - 1) !== feedback.testimonial.testimonial.substring(0, feedback.testimonial.title.length - 1) ?
                      <React.Fragment>
                        <span className={this.state.itemClass + '__course__heading h4'}>{'Feedback: '}</span>
                        <p className={this.state.itemClass + '__text__course text-content'}> {feedback.testimonial.title}</p>
                        <p className={this.state.itemClass + '__text__content text-content'}>{feedback.testimonial.testimonial}</p>
                      </React.Fragment>
                      :
                      <React.Fragment>
                        {/* else */}
                        <span className={this.state.itemClass + '__course__heading h4'}> {'Feedback:'}</span>
                        <p className={this.state.itemClass + '__text__content text-content'}>{feedback.testimonial.testimonial}</p>
                      </React.Fragment>
                    }
                  </div>
                </React.Fragment>
              ) : ''}
            </Carousel>
            <div className="col-md-12 rule--solid margin--btm50 margin--tp50"></div>
          </div>
          : ''}
      </React.Fragment>
    );
  }
}
export default LearnerFeedbackCarousel;
